export const blockIconsAudioandvideoStopCircle = (
	<span className='material-symbols-outlined'>stop_circle</span>
);
